module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-admin"
  }, [_c('file-progress'), _vm._v(" "), (_vm.video) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "panel col-xs-12 col-md-8 video-player-wrapper"
  }, [_c('breadcrumbs', {
    attrs: {
      "breadcrumbs": [{
          title: 'Dashboard',
          link: '/'
        },
        {
          title: _vm.path,
          link: _vm.$route.fullPath
        },
        {
          title: _vm.video.course.name,
          link: '/course-admin/' + _vm.courseId + '/' + _vm.instanceId + '?path_name=' + _vm.path + '&term_name=' + _vm.term
        },
        {
          title: _vm.video.title,
          link: _vm.$route.fullPath
        } ]
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clear-me"
  }, [_vm._v("You are editing:")]), _vm._v(" "), _c('div', {
    staticClass: "sku"
  }, [_vm._v("\n                " + _vm._s(_vm.video.sku) + "\n            ")]), _vm._v(" "), (!_vm.unsyncedSKUs.includes(_vm.video.sku) && _vm.videoTerm && new Date(_vm.videoTerm.endDate) > new Date()) ? _c('div', [(_vm.syncedLessons.length) ? _c('div', [_vm._v("Which will also edit the same lesson in:")]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "synced-lessons"
  }, _vm._l((_vm.syncedLessons), function(lesson) {
    return _c('li', [_c('router-link', {
      attrs: {
        "to": {
          name: 'videoChapters',
          params: {
            courseId: lesson.course_instance.course,
            instanceId: lesson.course_instance.id,
            videoId: lesson.id
          },
          query: {
            path: _vm.getPathForCourse(lesson.course_instance.associated.id),
            term: lesson.course_instance.associated_term.name,
            week: lesson.week
          }
        },
        "target": "_blank"
      }
    }, [_vm._v("\n                            " + _vm._s(lesson.course_instance.associated_term.name) + ", " + _vm._s(_vm.getPathForCourse(lesson.course_instance.associated.id)) + ", " + _vm._s(lesson.course_instance.associated.name) + ", Week " + _vm._s(lesson.week) + "\n                        ")])], 1)
  }))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "student-view"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openStudentView()
      }
    }
  }, [_vm._v("Student View")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v(_vm._s(_vm.video.title) + " — Week " + _vm._s(_vm.video.week))])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.selectedChapter) ? _c('poly-video', {
    key: _vm.selectedChapter.id,
    ref: "videoPlayer",
    attrs: {
      "sources": [_vm.videoPlayerUrl],
      "vjsOptions": _vm.videoPlayerVjsOptions,
      "persistPlaybackSpeed": true,
      "persistPlaybackQuality": true
    },
    on: {
      "play": function($event) {
        _vm.getComments()
      },
      "ready": function($event) {
        _vm.getAnnotations($event), _vm.getMarkers($event)
      },
      "timeupdate": function($event) {
        _vm.onPlayerTimeupdate($event)
      }
    }
  }) : _c('img', {
    staticClass: "video-player-placeholder",
    attrs: {
      "src": require("./../assets/img/video-admin-placeholder.png"),
      "alt": "Video Player"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs clearfix"
  }, [_c('ul', [_c('li', {
    class: {
      'active': _vm.showTab === 'description'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'description'
      }
    }
  }, [_vm._v("\n                            Description\n                            "), (_vm.video.lesson_files.length === 0 && _vm.requires('files')) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'exercise'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'exercise'
      }
    }
  }, [_vm._v("\n                            Exercise\n                            "), (!_vm.video.exercise && _vm.requires('exercise')) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'assignment'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'assignment'
      }
    }
  }, [_vm._v("\n                            Assignment\n                            "), (!_vm.video.assignment && _vm.requires('assignment')) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'comments'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'comments'
      }
    }
  }, [_vm._v("\n                            Comments\n                            "), (_vm.comments) ? _c('span', {
    staticClass: "badge"
  }, [_vm._v(_vm._s(_vm.comments.length))]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'resources'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'resources'
      }
    }
  }, [_vm._v("\n                            Resources\n                            "), (_vm.video.resources.length === 0 && _vm.requires('resources')) ? _c('span', {
    staticClass: "required"
  }, [_vm._v("!")]) : _vm._e()]), _vm._v(" "), _c('li', {
    class: {
      'active': _vm.showTab === 'transcript'
    },
    on: {
      "click": function($event) {
        _vm.selectedTab = 'transcript'
      }
    }
  }, [_vm._v("Live Transcript")])])])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedTab === 'description'),
      expression: "selectedTab==='description'"
    }],
    staticClass: "panel"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('h4', [_vm._v("Lesson Description:")]), _vm._v(" "), _c('p', [_vm._v("The Lesson Description is the full outline for this course's weekly lesson. It should outline everything and be the expanded version of the weekly summary. Things to include would be what is covered this week and expected, for this course.")]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.videoDescription
    },
    on: {
      "change": _vm.updateVideoDescription
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveDescription()
      }
    }
  }, [_vm._v("Save Lesson Description")]), _vm._v(" "), (_vm.requires('files')) ? _c('div', [_c('h4', [_vm._v("Lesson Files:")]), _vm._v(" "), _c('p', [_vm._v("Lesson Files are files for the lesson that wouldn't be 'course resources' or respective 'exercise files' - usually just the course outline as PDF, or anything else referenced from the videos directly, scene files, source materials etc.")]), _vm._v(" "), (_vm.video && _vm.video.lesson_files) ? _c('table', {
    staticClass: "assignment-files table table-striped "
  }, [_c('tbody', _vm._l((_vm.video.lesson_files), function(file, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": file.url,
        "_target": "blank"
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file.url)))])]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteLessonFile(file.id, index)
        }
      }
    }, [_vm._v("Delete")])])])
  }))]) : _vm._e(), _vm._v(" "), _c('dropzone', {
    ref: "lessonFiles",
    attrs: {
      "id": "lessonFiles",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addLessonFiles()
      }
    }
  }, [_vm._v("Upload Lesson Files")])], 1) : _vm._e(), _vm._v(" "), (_vm.video.lesson_files.length < 1) ? _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "checkbox-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRequirement('files')
      }
    }
  }, [_vm._v("\n                            There are no lesson files this week\n                            "), (_vm.requires('files')) ? _c('i', {
    staticClass: "fa fa-square-o"
  }) : _vm._e(), _vm._v(" "), (!_vm.requires('files')) ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedTab === 'assignment') ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.video.assignment) ? _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Available: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.availableDate),
      expression: "video.assignment.availableDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.video.assignment.availableDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.assignment.availableDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('b', [_vm._v("Due: ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.dueDate),
      expression: "video.assignment.dueDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.video.assignment.dueDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.assignment.dueDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Final Project")]), _vm._v(" "), _c('label', [_vm._v("Yes "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.isFinalProject),
      expression: "video.assignment.isFinalProject"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.video.assignment.isFinalProject) ? _vm._i(_vm.video.assignment.isFinalProject, null) > -1 : (_vm.video.assignment.isFinalProject)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.video.assignment.isFinalProject,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.video.assignment.isFinalProject = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.video.assignment.isFinalProject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.video.assignment.isFinalProject = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.name),
      expression: "video.assignment.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.video.assignment.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.assignment.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Difficulty Level")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.difficulty),
      expression: "video.assignment.difficulty"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.video.assignment.difficulty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l(((1, 5)), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Points")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.assignment.points),
      expression: "video.assignment.points"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.video.assignment.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.assignment.points = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Description")]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.video.assignment.description,
      "height": 200
    },
    on: {
      "change": _vm.changeAssignmentDescription
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Assignment Image")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.video.assignment.image
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeAssignmentImage($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }), _vm._v(" "), _c('h5', [_vm._v("Files")]), _vm._v(" "), _vm._m(2), _vm._v(" "), (_vm.video.assignment.watermarkingInProgress) ? _c('h6', [_vm._v("Watermarking in progress.")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "assignment-files table table-striped "
  }, [_c('tbody', _vm._l((_vm.video.assignment.files), function(file, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": file,
        "_target": "blank"
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])]), _vm._v(" "), (!_vm.video.assignment.watermarkingInProgress) ? _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteFile('assignment', index)
        }
      }
    }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), _c('td', [(!_vm.video.assignment.watermarkingInProgress) ? _c('button', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.protectFile('assignment', _vm.video.assignment, file)
        }
      }
    }, [_vm._v("\n                                                Protect")]) : _vm._e()])])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "accept": "application/zip"
    },
    on: {
      "change": function($event) {
        _vm.uploadAssignmentFiles($event)
      }
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Watermarked Files")]), _vm._v(" "), _c('table', {
    staticClass: "assignment-files table table-striped "
  }, [_c('tbody', _vm._l((_vm.video.assignment.watermarkedFiles), function(file, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'assignment', _vm.video.assignment.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))]), _vm._v(" "), (_vm.isDirector) ? _c('span', [_vm._v("("), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'assignment', _vm.video.assignment.id, true)
        }
      }
    }, [_vm._v("source")]), _vm._v(")")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteWatermarkedFile(file, 'assignment', _vm.video.assignment.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateAssignment()
      }
    }
  }, [_vm._v("Update")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteAssignment(_vm.video.assignment.id)
      }
    }
  }, [_vm._v("Delete")])])])]) : _c('div', [(_vm.requires('assignment')) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addAssignment()
      }
    }
  }, [_c('h4', {
    staticClass: "create-assignment-title"
  }, [_vm._v("Create a New Assignment")]), _vm._v(" "), _c('p', [_vm._v("You can create new assignments below:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Enter Assignment Name on white line'),
      expression: "'Enter Assignment Name on white line'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignment.name),
      expression: "assignment.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name",
      "required": ""
    },
    domProps: {
      "value": (_vm.assignment.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assignment.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Add the assignment description here, you can use bullets and bolds to outline requirements etc'),
      expression: "'Add the assignment description here, you can use bullets and bolds to outline requirements etc'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.assignment.description,
      "height": 200
    },
    on: {
      "change": _vm.updateAssignmentDescription
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Points are a Populi thing, they are all relative so 3 assignments set to 5, 5, 7 will weigh the last one more for marks'),
      expression: "'Points are a Populi thing, they are all relative so 3 assignments set to 5, 5, 7 will weigh the last one more for marks'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignment.points),
      expression: "assignment.points"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Points",
      "required": ""
    },
    domProps: {
      "value": (_vm.assignment.points)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assignment.points = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Difficult level is for us to graph a week work load. This should be in your Realtimeboard'),
      expression: "'Difficult level is for us to graph a week work load. This should be in your Realtimeboard'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('label', [_vm._v("Difficulty Level")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignment.difficulty),
      expression: "assignment.difficulty"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignment.difficulty = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l(((1, 5)), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(i))])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Final Project")]), _vm._v(" "), _c('label', [_vm._v("Yes "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignment.isFinalProject),
      expression: "assignment.isFinalProject"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.assignment.isFinalProject) ? _vm._i(_vm.assignment.isFinalProject, null) > -1 : (_vm.assignment.isFinalProject)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.assignment.isFinalProject,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.assignment.isFinalProject = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.assignment.isFinalProject = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.assignment.isFinalProject = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('br'), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('If it is a longer assignment you can set how many weeks before it is due, default is one week'),
      expression: "'If it is a longer assignment you can set how many weeks before it is due, default is one week'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "multiweek"
    }
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "id": "multiweek"
    },
    on: {
      "change": function($event) {
        _vm.isMultiWeek = !_vm.isMultiWeek
      }
    }
  }), _vm._v("Multi-week Assignment")])]), _vm._v(" "), (_vm.isMultiWeek) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Duration in Weeks")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assignment.duration),
      expression: "assignment.duration"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.assignment.duration = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l(((1, 14)), function(i) {
    return _c('option', [_vm._v(_vm._s(i))])
  }))]) : _vm._e(), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Drag Your Files here that are for the assignment - References, PDFs, Maya, zip files etc, you can queue more than one. They will upload when you create the assignment.'),
      expression: "'Drag Your Files here that are for the assignment - References, PDFs, Maya, zip files etc, you can queue more than one. They will upload when you create the assignment.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _c('br'), _vm._v(" "), _c('dropzone', {
    ref: "assignmentFiles",
    attrs: {
      "id": "assignmentFiles",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 25,
      "dropzone-options": _vm.dropzoneOptions
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('An assignment image is the featured image, it shows in the description as a popup and also as the assignment background! Usually its for the final result etc.'),
      expression: "'An assignment image is the featured image, it shows in the description as a popup and also as the assignment background! Usually its for the final result etc.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _c('label', [_vm._v("Assignment Featured Image")]), _vm._v(" "), _c('input', {
    ref: "assignmentImage",
    staticClass: "form-control",
    attrs: {
      "type": "file"
    }
  })]), _vm._v(" "), _vm._m(3)], 1) : _vm._e()]), _vm._v(" "), (!_vm.video.assignment) ? _c('div', {
    staticClass: "text-right"
  }, [_c('div', {
    staticClass: "checkbox-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRequirement('assignment')
      }
    }
  }, [_vm._v("\n                            There is no assignment this week\n                            "), (_vm.requires('assignment')) ? _c('i', {
    staticClass: "fa fa-square-o"
  }) : _vm._e(), _vm._v(" "), (!_vm.requires('assignment')) ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'exercise') ? _c('div', {
    staticClass: "panel exercise"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.requires('exercise')) ? _c('div', [(!_vm.video.exercise) ? _c('h4', {
    staticClass: "create-assignment-title"
  }, [_vm._v("Create a New Exercise")]) : _vm._e(), _vm._v(" "), (!_vm.video.exercise) ? _c('p', [_vm._v("Below you can add an Exercise to this week's lesson in this course."), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.video && _vm.video.exercise) ? _c('div', [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.exercise.title),
      expression: "video.exercise.title"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.video.exercise.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.exercise.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Set the date the exercise is due.'),
      expression: "'Set the date the exercise is due.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('label', [_vm._v("Due Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.exercise.dueDate),
      expression: "video.exercise.dueDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.video.exercise.dueDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.exercise.dueDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Description:")]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.video.exercise.description,
      "height": 200
    },
    on: {
      "change": _vm.changeExerciseDescription
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Exercise Image")]), _vm._v(" "), (_vm.video.exercise.image) ? _c('img', {
    attrs: {
      "src": _vm.video.exercise.image
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.changeExerciseImage($event)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('h5', [_vm._v("Files")]), _vm._v(" "), (_vm.video.exercise.watermarkingInProgress) ? _c('h6', [_vm._v("Watermarking in progress")]) : _vm._e(), _vm._v(" "), _c('table', {
    staticClass: "assignment-files table table-striped "
  }, [_c('tbody', _vm._l((_vm.video.exercise.files), function(file, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": file,
        "_target": "blank"
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))])]), _vm._v(" "), (!_vm.video.exercise.watermarkingInProgress) ? _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteFile('exercise', index)
        }
      }
    }, [_vm._v("Delete")])]) : _vm._e(), _vm._v(" "), (!_vm.video.exercise.watermarkingInProgress) ? _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.protectFile('exercise', _vm.video.exercise, file)
        }
      }
    }, [_vm._v("\n                                                        Protect")])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "file"
    },
    on: {
      "change": function($event) {
        _vm.uploadExerciseFiles($event)
      }
    }
  })]), _vm._v(" "), _c('h5', [_vm._v("Watermarked Files")]), _vm._v(" "), _c('table', {
    staticClass: "assignment-files table table-striped "
  }, [_c('tbody', _vm._l((_vm.video.exercise.watermarkedFiles), function(file, index) {
    return _c('tr', {
      staticClass: "list-group-item"
    }, [_c('td', [_c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'exercise', _vm.video.exercise.id)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("filenameFromUrl")(file)))]), _vm._v(" "), (_vm.isDirector) ? _c('span', [_vm._v("("), _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.downloadFile(file, 'exercise', _vm.video.exercise.id, true)
        }
      }
    }, [_vm._v("source")]), _vm._v(")")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('button', {
      staticClass: "btn btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteWatermarkedFile(file, 'exercise', _vm.video.exercise.id)
        }
      }
    }, [_vm._v("Delete")])])])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.exercise.fileRequired),
      expression: "video.exercise.fileRequired"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.video.exercise.fileRequired) ? _vm._i(_vm.video.exercise.fileRequired, null) > -1 : (_vm.video.exercise.fileRequired)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.video.exercise.fileRequired,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.video.exercise.fileRequired = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.video.exercise.fileRequired = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.video.exercise.fileRequired = $$c
        }
      }
    }
  }), _vm._v("File upload required")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group buttons"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateExercise()
      }
    }
  }, [_vm._v("Update")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 text-right"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteExercise()
      }
    }
  }, [_vm._v("Delete")])])])])]) : _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createExercise()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Enter exercise name on white line.'),
      expression: "'Enter exercise name on white line.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.title),
      expression: "exercise.title"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Title"
    },
    domProps: {
      "value": (_vm.exercise.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exercise.title = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Set the date the exercise is due.'),
      expression: "'Set the date the exercise is due.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('label', [_vm._v("Due Date")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.dueDate),
      expression: "exercise.dueDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date"
    },
    domProps: {
      "value": (_vm.exercise.dueDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.exercise.dueDate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Fill out exercise details and requirements, you can use bullets, bolds etc for better formatting.'),
      expression: "'Fill out exercise details and requirements, you can use bullets, bolds etc for better formatting.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.exerciseDescription,
      "height": 200
    },
    on: {
      "change": _vm.updateExerciseDescription
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group clearfix"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Check Hand-In File Required if they need to submit something and not just self assess.'),
      expression: "'Check Hand-In File Required if they need to submit something and not just self assess.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _c('label', [_vm._v("Hand-in File Required? "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.exercise.fileRequired),
      expression: "exercise.fileRequired"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.exercise.fileRequired) ? _vm._i(_vm.exercise.fileRequired, null) > -1 : (_vm.exercise.fileRequired)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.exercise.fileRequired,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.exercise.fileRequired = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.exercise.fileRequired = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.exercise.fileRequired = $$c
        }
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('An exercise image is the featured image, it shows in the description as a popup and also as the exercise background! Usually its for the final result etc.'),
      expression: "'An exercise image is the featured image, it shows in the description as a popup and also as the exercise background! Usually its for the final result etc.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _c('label', [_vm._v("Exercise Featured Image:")]), _vm._v(" "), _c('input', {
    ref: "exerciseImage",
    staticClass: "form-control exercise-image-upload",
    attrs: {
      "type": "file"
    }
  })]), _vm._v(" "), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Drag Your Files here that are for the excerise - References, PDFs, Maya, zip files etc, you can queue more than one. They will upload when you create the excerise.'),
      expression: "'Drag Your Files here that are for the excerise - References, PDFs, Maya, zip files etc, you can queue more than one. They will upload when you create the excerise.'"
    }],
    staticClass: "clippie clippie-float-right fa fa-info-circle"
  }), _c('br'), _vm._v(" "), _c('dropzone', {
    ref: "exerciseFiles",
    attrs: {
      "id": "exerciseFiles",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })]), _vm._v(" "), _vm._m(5)], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(!_vm.video.exercise) ? _c('div', {
    staticClass: "checkbox-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRequirement('exercise')
      }
    }
  }, [_vm._v("\n                            There is no exercise this week\n                            "), (_vm.requires('exercise')) ? _c('i', {
    staticClass: "fa fa-square-o"
  }) : _vm._e(), _vm._v(" "), (!_vm.requires('exercise')) ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'comments') ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(6), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [(_vm.comments) ? _c('ul', {
    staticClass: "comments"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('li', [_c('div', {
      staticClass: "row top-level"
    }, [_c('div', {
      staticClass: "col-xs-2"
    }, [(comment.user.avatar) ? _c('img', {
      attrs: {
        "src": comment.user.avatar
      }
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7"
    }, [_c('p', {
      staticClass: "author"
    }, [_vm._v("\n                                        " + _vm._s(comment.user.firstName) + " " + _vm._s(comment.user.lastName) + " at "), _c('span', {
      on: {
        "click": function($event) {
          _vm.jumpToTime(comment.time)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(comment.text)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-3"
    }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(comment.createdAt)) + " ago")]), _vm._v(" "), _c('div', [_c('button', {
      staticClass: "btn btn-xs reply-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.showReplyForm = comment.id
        }
      }
    }, [_vm._v("Reply")]), _vm._v(" "), (_vm.localStorage.roles.includes('CourseAdmin') || _vm.localStorage.roles.includes('Admin')) ? _c('button', {
      staticClass: "btn btn-xs delete-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteComment(comment)
        }
      }
    }, [_vm._v("\n                                            Delete\n                                        ")]) : _vm._e()])])]), _vm._v(" "), (comment.children.length > 0) ? _c('ul', {
      staticClass: "replies"
    }, _vm._l((comment.children), function(child) {
      return _c('li', [_c('div', {
        staticClass: "row"
      }, [_c('div', {
        staticClass: "col-xs-2"
      }, [(child.user.avatar) ? _c('img', {
        attrs: {
          "src": child.user.avatar
        }
      }) : _vm._e()]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-7"
      }, [_c('p', {
        staticClass: "author"
      }, [_vm._v("\n                                                " + _vm._s(child.user.firstName) + " " + _vm._s(child.user.lastName) + " at "), _c('span', {
        on: {
          "click": function($event) {
            _vm.jumpToTime(comment.time)
          }
        }
      }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(comment.time)))])]), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(child.text)
        }
      }), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
        staticClass: "col-xs-3"
      }, [_c('div', [_vm._v(_vm._s(_vm._f("timeSince")(child.createdAt)) + " ago")]), _vm._v(" "), (_vm.localStorage.roles.includes('CourseAdmin') || _vm.localStorage.roles.includes('Admin')) ? _c('button', {
        staticClass: "btn btn-xs delete-button",
        on: {
          "click": function($event) {
            $event.preventDefault();
            _vm.deleteComment(child)
          }
        }
      }, [_vm._v("\n                                                Delete\n                                            ")]) : _vm._e()])])])
    })) : _vm._e(), _vm._v(" "), (_vm.showReplyForm === comment.id) ? _c('form', {
      on: {
        "submit": function($event) {
          $event.preventDefault();
          _vm.addComment(comment.id, comment.user)
        }
      }
    }, [_c('div', {
      staticClass: "form-group"
    }, [_c('vue-html5-editor', {
      attrs: {
        "content": _vm.content,
        "height": 200
      },
      on: {
        "change": function($event) {
          _vm.updateCommentReply($event, comment.id)
        }
      }
    })], 1), _vm._v(" "), _c('button', {
      staticClass: "btn btn-xs reply-button",
      attrs: {
        "type": "submit"
      }
    }, [_vm._v("Submit Comment Reply")])]) : _vm._e()])
  })) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.addComment()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Add Timeline Comment:"), _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ('Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'),
      expression: "'Add and reply to comments directly on the timeline. Great for asking and answering questions specific to a point in time. Set your time marker to a place and add a comment!'"
    }],
    staticClass: "clippie fa fa-info-circle"
  })]), _vm._v(" "), _c('vue-html5-editor', {
    attrs: {
      "content": _vm.content,
      "height": 200
    },
    on: {
      "change": _vm.updateComment
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add Comment")])])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'resources') ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "panel-body resources"
  }, [(_vm.requires('resources')) ? _c('div', [_c('div', {
    staticClass: "resource-table"
  }, [_c('ul', _vm._l((_vm.video.resources), function(resource, index) {
    return _c('li', [_c('a', {
      attrs: {
        "href": resource.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(resource.name))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(resource.description))]), _vm._v(" "), (resource.watermarkingInProgress) ? _c('p', [_vm._v("Watermarking in progress")]) : _vm._e(), _vm._v(" "), (!resource.watermarked) ? _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteResource(resource, index)
        }
      }
    }, [_vm._v("\n                                            Delete\n                                        ")]), _vm._v(" "), (!resource.watermarkingInProgress && resource.url.includes('ttto-course-files')) ? _c('button', {
      staticClass: "btn-xs btn-success",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.protectFile('resource', resource, resource.url)
        }
      }
    }, [_vm._v("\n                                            Protect\n                                        ")]) : _vm._e(), _vm._v(" "), (resource.watermarkingInProgress) ? _c('span', [_vm._v("Watermarking in progress")]) : _vm._e()]) : _c('div', {
      staticClass: "buttons"
    }, [_c('button', {
      staticClass: "btn-xs btn-danger",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteWatermarkedFile(resource.url, 'resource', resource.id)
        }
      }
    }, [_vm._v("\n                                            Delete\n                                        ")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-primary",
      on: {
        "click": function($event) {
          $event.preventDefault();
        }
      }
    }, [_vm._v("Protected")])])])
  }))]), _vm._v(" "), _c('p', [_vm._v("Here you can add resources for this course, tied to this week. Name and Description are required and either the resource would be an external URL like to a website, or you can add a file, be it a zip, PDF, image etc!")]), _vm._v(" "), _c('p', [_vm._v("They also will be in the Course Resource Directory in the left menu.")]), _vm._v(" "), (_vm.course) ? _c('file-list', {
    attrs: {
      "instanceId": _vm.course.instanceid
    }
  }) : _vm._e(), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.uploadResource()
      }
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.name),
      expression: "file.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.file.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.description),
      expression: "file.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Description"
    },
    domProps: {
      "value": (_vm.file.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.description = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.file.url),
      expression: "file.url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "URL"
    },
    domProps: {
      "value": (_vm.file.url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.file.url = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Or upload file:")]), _vm._v(" "), _c('input', {
    ref: "file",
    staticClass: "form-control",
    attrs: {
      "type": "file",
      "name": "file"
    }
  })]), _vm._v(" "), _vm._m(8)])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "text-right"
  }, [(_vm.video.resources.length < 1) ? _c('div', {
    staticClass: "checkbox-wrapper",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.toggleRequirement('resources')
      }
    }
  }, [_vm._v("\n                            There are no resources this week\n                            "), (_vm.requires('resources')) ? _c('i', {
    staticClass: "fa fa-square-o"
  }) : _vm._e(), _vm._v(" "), (!_vm.requires('resources')) ? _c('i', {
    staticClass: "fa fa-check-square-o"
  }) : _vm._e()]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'transcript') ? _c('div', {
    staticClass: "panel annotation"
  }, [_vm._m(9), _vm._v(" "), (_vm.selectedChapter) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("Annotations and Flyouts are a great way to overlay additional captions to your videos. Even just text like a caption for further information. Or you could say \"Tumble Viewport\" and set the shortcut below. ")]), _vm._v(" "), _c('p', [_vm._v("First drag the timeline dot to set the place in the video lesson you'd like to add the annoation.")]), _vm._v(" "), _c('p', [_vm._v("You can edit and delete annotations by finding them in the timeline and clicking either the delete icon or pencil icon to edit them.")]), _vm._v(" "), _c('p', [_vm._v("Shortcuts, modifier keys, mouse clicks are entirely optional.")]), _vm._v(" "), _c('p', [_vm._v("Left and Right is which location the fly-out appears over the video.")]), _vm._v(" "), _c('form', [(!_vm.editMode) ? _c('div', {
    staticClass: "form-group"
  }, [_c('h4', [_c('br'), _vm._v("Add Annotation at\n                                "), _c('input', {
    ref: "timecode",
    staticClass: "timecode form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._f("timecode")(_vm.currentTime)
    },
    on: {
      "keyup": function($event) {
        _vm.jumpToTimecode($event)
      }
    }
  })])]) : _c('div', {
    staticClass: "form-group"
  }, [_vm._v("Editing annotation at " + _vm._s(_vm.annotation.time))]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annotation.text),
      expression: "annotation.text"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Text"
    },
    domProps: {
      "value": (_vm.annotation.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.annotation.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "buttons"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controlKeys),
      expression: "controlKeys"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "ctrl",
      "id": "ctrl"
    },
    domProps: {
      "checked": Array.isArray(_vm.controlKeys) ? _vm._i(_vm.controlKeys, "ctrl") > -1 : (_vm.controlKeys)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.controlKeys,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "ctrl",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.controlKeys = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.controlKeys = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.controlKeys = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "key",
    attrs: {
      "for": "ctrl"
    }
  }, [_vm._v("CTRL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controlKeys),
      expression: "controlKeys"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "alt",
      "id": "alt"
    },
    domProps: {
      "checked": Array.isArray(_vm.controlKeys) ? _vm._i(_vm.controlKeys, "alt") > -1 : (_vm.controlKeys)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.controlKeys,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "alt",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.controlKeys = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.controlKeys = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.controlKeys = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "key",
    attrs: {
      "for": "alt"
    }
  }, [_vm._v("ALT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.controlKeys),
      expression: "controlKeys"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "shift",
      "id": "shift"
    },
    domProps: {
      "checked": Array.isArray(_vm.controlKeys) ? _vm._i(_vm.controlKeys, "shift") > -1 : (_vm.controlKeys)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.controlKeys,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "shift",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.controlKeys = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.controlKeys = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.controlKeys = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "key",
    attrs: {
      "for": "shift"
    }
  }, [_vm._v("SHIFT")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mouseButtons),
      expression: "mouseButtons"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "lmb",
      "id": "lmb"
    },
    domProps: {
      "checked": Array.isArray(_vm.mouseButtons) ? _vm._i(_vm.mouseButtons, "lmb") > -1 : (_vm.mouseButtons)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.mouseButtons,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "lmb",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mouseButtons = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mouseButtons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mouseButtons = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "mouse",
    attrs: {
      "for": "lmb"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mouseButtons),
      expression: "mouseButtons"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "cmb",
      "id": "cmb"
    },
    domProps: {
      "checked": Array.isArray(_vm.mouseButtons) ? _vm._i(_vm.mouseButtons, "cmb") > -1 : (_vm.mouseButtons)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.mouseButtons,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "cmb",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mouseButtons = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mouseButtons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mouseButtons = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "mouse",
    attrs: {
      "for": "cmb"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mouseButtons),
      expression: "mouseButtons"
    }],
    staticClass: "key",
    attrs: {
      "type": "checkbox",
      "value": "rmb",
      "id": "rmb"
    },
    domProps: {
      "checked": Array.isArray(_vm.mouseButtons) ? _vm._i(_vm.mouseButtons, "rmb") > -1 : (_vm.mouseButtons)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.mouseButtons,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "rmb",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.mouseButtons = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.mouseButtons = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.mouseButtons = $$c
        }
      }
    }
  }), _c('label', {
    staticClass: "mouse",
    attrs: {
      "for": "rmb"
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hotKeys),
      expression: "hotKeys"
    }],
    staticClass: "hotkey form-control",
    attrs: {
      "type": "text",
      "placeholder": "Key"
    },
    domProps: {
      "value": (_vm.hotKeys)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.hotKeys = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annotation.position),
      expression: "annotation.position"
    }],
    attrs: {
      "type": "radio",
      "value": "left"
    },
    domProps: {
      "checked": _vm._q(_vm.annotation.position, "left")
    },
    on: {
      "__c": function($event) {
        _vm.annotation.position = "left"
      }
    }
  }), _vm._v("Left\n                            "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.annotation.position),
      expression: "annotation.position"
    }],
    attrs: {
      "type": "radio",
      "value": "right"
    },
    domProps: {
      "checked": _vm._q(_vm.annotation.position, "right")
    },
    on: {
      "__c": function($event) {
        _vm.annotation.position = "right"
      }
    }
  }), _vm._v("Right\n                            "), (_vm.editMode === false) ? _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Add Annotation"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addAnnotation($event)
      }
    }
  }) : _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Update"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateAnnotation($event)
      }
    }
  })])]), _vm._v(" "), _c('table', {
    staticClass: "annotations"
  }, [_vm._m(10), _vm._v(" "), _c('tbody', _vm._l((_vm.selectedChapter.annotations), function(annotation) {
    return _c('tr', [_c('td', [_vm._v(_vm._s(_vm._f("timecode")(annotation.time)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(annotation.text))]), _vm._v(" "), _c('td', [_c('i', {
      staticClass: "fa fa-pencil",
      on: {
        "click": function($event) {
          _vm.editAnnotation(annotation.id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash-o",
      on: {
        "click": function($event) {
          _vm.deleteAnnotation(annotation.id)
        }
      }
    })])])
  }))])]) : _c('div', [_vm._v("Please select a chapter")])]) : _vm._e(), _vm._v(" "), (_vm.selectedTab === 'transcript') ? _c('div', {
    staticClass: "panel"
  }, [_vm._m(11), _vm._v(" "), (_vm.selectedChapter) ? _c('div', {
    staticClass: "panel-body"
  }, [_c('p', [_vm._v("You can review the select chapter's video transcript below.\n                        ("), (_vm.video.video_chapters && _vm.video.video_chapters.length) ? _c('a', {
    staticClass: "bold underline",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.copyTranscript()
      }
    }
  }, [_vm._v("Click to copy all lesson chapter transcripts")]) : _vm._e(), _vm._v(")\n                    ")]), _vm._v(" "), _c('p', [_vm._v("They sometimes take up to an hour to generate but will appear once ready!")]), _vm._v(" "), _c('p', [_vm._v("You can edit them directly below and save your changes if they need improving.")]), _vm._v(" "), (_vm.selectedChapter && _vm.selectedChapter.transcript) ? _c('div', {
    staticClass: "transcript"
  }, [_c('div', {
    ref: "text",
    staticClass: "text well"
  }, _vm._l((_vm.selectedChapter.transcript.text), function(phrase, index) {
    return _c('span', {
      attrs: {
        "contenteditable": "true"
      },
      on: {
        "keyup": function($event) {
          _vm.updateText($event, index)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("nobreak")(phrase.text)) + " ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateTranscript($event)
      }
    }
  }, [_vm._v("Save Transcript Edits")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedChapter) ? _c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.regenerateTranscript()
      }
    }
  }, [_vm._v("Regenerate Transcript")]) : _vm._e()]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "panel chapters-panel col-xs-12 col-md-4"
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('draggable', {
    staticClass: "chapters list-group",
    attrs: {
      "tag": "ul",
      "handle": ".handle"
    },
    on: {
      "end": function($event) {
        _vm.reorder($event)
      }
    },
    model: {
      value: (_vm.video.video_chapters),
      callback: function($$v) {
        _vm.video.video_chapters = $$v
      },
      expression: "video.video_chapters"
    }
  }, _vm._l((_vm.video.video_chapters), function(chapter, index) {
    return _c('li', {
      staticClass: "row"
    }, [(chapter.heading) ? _c('div', {
      staticClass: "col-xs-12 chapter-heading form-group"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.heading),
        expression: "chapter.heading"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (chapter.heading)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          chapter.heading = $event.target.value
        }
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "col-xs-7"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.title),
        expression: "chapter.title"
      }],
      staticClass: "form-control",
      class: {
        'selected': _vm.selectedChapter.id === chapter.id
      },
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (chapter.title)
      },
      on: {
        "click": function($event) {
          _vm.selectChapter(chapter)
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          chapter.title = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-5 buttons"
    }, [_c('i', {
      staticClass: "fa fa-save",
      on: {
        "click": function($event) {
          _vm.rename(chapter, chapter.id)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-copy",
      attrs: {
        "title": "Copy chapter title and ID to clipboard"
      },
      on: {
        "click": function($event) {
          _vm.copyChapter(chapter)
        }
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "fa fa-trash",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteChapter(chapter.id, index)
        }
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "duration",
      on: {
        "click": function($event) {
          _vm.selectChapter(chapter)
        }
      }
    }, [_vm._v(_vm._s(_vm._f("minutesAndSeconds")(chapter.duration)))]), _vm._v(" "), _c('i', {
      staticClass: "fa fa-arrows-v handle",
      attrs: {
        "title": "Drag to re-order"
      }
    })])])
  })), _vm._v(" "), _c('dropzone', {
    ref: "newChapters",
    attrs: {
      "id": "newChapters",
      "url": "#",
      "use-custom-dropzone-options": true,
      "thumbnail-height": 0,
      "dropzone-options": _vm.dropzoneOptions
    },
    on: {
      "vdropzone-file-added": _vm.chapterAdded
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "token",
      "value": "xxx"
    }
  })]), _vm._v(" "), _c('draggable', {
    staticClass: "chapters list-group",
    model: {
      value: (_vm.chapters),
      callback: function($$v) {
        _vm.chapters = $$v
      },
      expression: "chapters"
    }
  }, _vm._l((_vm.chapters), function(chapter) {
    return _c('li', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.title),
        expression: "chapter.title"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Title"
      },
      domProps: {
        "value": (chapter.title)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          chapter.title = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (chapter.heading),
        expression: "chapter.heading"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "placeholder": "Group Heading (optional)"
      },
      domProps: {
        "value": (chapter.heading)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          chapter.heading = $event.target.value
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-12"
    }, [_vm._v("\n                            " + _vm._s(chapter.name) + "\n                        ")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "form-group upload text-right"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addChapters($event)
      }
    }
  }, [_vm._v("Upload")])])], 1), _vm._v(" "), _vm._m(13), _vm._v(" "), _c('div', {
    staticClass: "panel-body summary"
  }, [_c('p', [_vm._v("Weekly summaries populate the course home table, they should only be max a few paragraphs in length. Excerpts of the 'lesson description' for each week. These need to be completed ahead of time as future summaries are visible to students.")]), _vm._v(" "), _c('div', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.saveDescription()
      }
    }
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.video.summary),
      expression: "video.summary"
    }],
    staticClass: "form-control",
    domProps: {
      "value": (_vm.video.summary)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.video.summary = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Save"
    }
  })])])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Lesson Description & Files")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading assignments"
  }, [_c('h2', [_c('img', {
    attrs: {
      "src": require("../assets/img/assignment-icon.png")
    }
  }), _vm._v("Assignments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('b', [_vm._v("If you watermark a file larger than 100MB in size, please inform development/IT afterwards so they can upload a pre-processed copy to the server")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit",
      "value": "Create Assignment"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Exercise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Create Exercise")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Comments")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Course Resources")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Add Course Resource")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Annotations & Flyouts")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Timecode")]), _vm._v(" "), _c('th', [_vm._v("Annotation")]), _vm._v(" "), _c('th', [_vm._v("Edit")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Transcript Editor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Chapters")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h2', [_vm._v("Weekly Summary")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-61b8f63e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoAdmin.vue
// module id = 2059
// module chunks = 2